// hooks/useFiltersLoader.js
import { useEffect, useContext } from "react";
import { Context } from "../index";
import { getAllFilters, getAvailableFilters } from "../http/productAPI";

const mergeFilters = (allFilters, availableFilters) => {
  return allFilters.map(filter => {
    const available = availableFilters.find(f => f.name === filter.name);
    if (!available) return null;

    const availableSet = new Set(available.values.map(v => v.name));

    return {
      ...filter,
      values: filter.values.filter(v => availableSet.has(v.name))
    };
  }).filter(Boolean);
};

export const useFiltersLoader = (filtersFromURLLoaded) => {
  const { product } = useContext(Context);

  useEffect(() => {
      // console.log ("useEffect useFiltersLoader")

    const loadFilters = async () => {
      if (!filtersFromURLLoaded || !product.selectedFolder?.id) return;

      try {
        const [allFilters, availableFilters] = await Promise.all([
          getAllFilters(product.selectedFolder.id),
          getAvailableFilters(product.selectedFolder.id, product.requestBodyFilter)
        ]);

        const merged = mergeFilters(allFilters, availableFilters);
        product.setFilters(merged);
      } catch (error) {
        console.error("Ошибка при загрузке фильтров:", error);
      }
    };

    loadFilters();
  }, [
    filtersFromURLLoaded,
    product.selectedFolder?.id,
    product.selectedFilters
  ]);
};


/* предлагал сделать отдельной утилитой mergeFilters - навсякий случай пока оставлю здесь.


/*export const mergeFilters = (allFilters = [], availableFilters = []) => {
  return allFilters
    .map((filter) => {
      const available = availableFilters.find(f => f.name === filter.name);
      if (!available) return null;

      const activeValues = filter.values?.filter(v =>
        available.values?.some(av => av.name === v.name && av.isActive)
      ) || [];

      if ((filter.type === "SELECT" && activeValues.length === 0) ||
          ((filter.type === "PRICE" || filter.type === "RANGE") &&
           (available.from === 0 && available.to === 0))) {
        return null;
      }

      return {
        ...filter,
        values: activeValues,
        from: available.from ?? filter.from,
        to: available.to ?? filter.to
      };
    })
    .filter(Boolean);
};*/
/*
export const mergeFilters = (allFilters, availableFilters) => {
  return allFilters.map(filter => {
    const matchingAvailable = availableFilters.find(f => f.name === filter.name);

    if (!matchingAvailable) return null; // скрыть фильтр полностью если он неактивен

    /*Хочешь отображать их как "неактивные" (например, disabled чекбоксы)? Тогда возвращай:

        return {
          ...filter,
          values: filter.values.map(v => ({
            ...v,
            isActive: availableValueNames.has(v.name)
          }))
        };

        И в Filter.jsx
        <Form.Check
          disabled={!value.isActive}
          ...
        />
        *//*
    const availableValueNames = new Set(matchingAvailable.values.map(v => v.name));

    return {
      ...filter,
      values: filter.values.filter(v => availableValueNames.has(v.name))
    };
  }).filter(Boolean); // убираем null
};*/
